import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxFontXsBoldProps extends ITextBoxProps {}

export const TextBoxFontXsBold = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontXsBold,
  alignment = TextAligning.Left,
  ...rest
}: ITextBoxFontXsBoldProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    {...rest}
  />
)
